import { axiosClient } from "@/lib/axios";
import { HttpError } from "@/types/error";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";

const removeTagFromRecording = async ({
  orgId,
  recordingId,
  tagId,
}: {
  orgId: string;
  recordingId: string;
  tagId: string;
}): Promise<void> => {
  const response = await axiosClient.delete(
    `${orgId}/recordings/${recordingId}/tags/${tagId}`,
  );
  return response.data;
};

export function useRemoveTagFromRecording(
  queryOptions?: UseMutationOptions<
    void,
    HttpError,
    { orgId: string; recordingId: string; tagId: string }
  >,
) {
  return useMutation({
    mutationFn: ({ orgId, recordingId, tagId }) =>
      removeTagFromRecording({ orgId, recordingId, tagId }),
    ...queryOptions,
  });
}
